<template>
	<div class=" cursorstyle">
		<div class="itemtop">
			<div class="left">
				工作台
			</div>
		</div>
		<div class="btnListbox">
			<div class="btnList">
				<div :class="btnListindex==index?'Select':''" v-for="(item,index) in btnList" :key="index" @click="btnclicke(item,index)">
					{{item.title}}
				</div>
			</div>
		</div>
		<div class="bigitembox">
			<div class="" style="width: 100%;">
				<template>
					<el-table :data="tableData" style="width: 100%" :row-class-name="tableRowClassName">
						<el-table-column  type="index" label="序号" show-overflow-tooltip width="50" align="center">
						</el-table-column>
						<el-table-column prop="name" label="名称" show-overflow-tooltip align="center">
						</el-table-column>
						<el-table-column prop="status_txt" label="状态" show-overflow-tooltip align="center">
						</el-table-column>
						<el-table-column prop="audit_time" label="日期" show-overflow-tooltip align="center">
						</el-table-column>
						<el-table-column prop="address" label="操作" show-overflow-tooltip align="center">
							<template slot-scope="scope">
								<span  v-if="btnListindex == 0"  style="color: #0094FF;"  type="text" size="small" @click="ApprovalBtn({mark:'Approval',item:scope.row})">审批</span>
								<span v-if="scope.row.status != 8 || scope.row.is_ok == 1" style="margin-left: 1vw; display: inline-block;"  type="text" size="small" @click="ApprovalBtn({mark:'see',item:scope.row})" >查看</span>
							</template>
						</el-table-column>
					</el-table>
				</template>
			</div>

		</div>
		<div class="" style="margin-top: 1vh; display: flex; justify-content: right;  margin-bottom: 2vh;">
			<div class="fenye">
				<!-- 分页 -->
				<el-pagination background   :page-size="5"
					layout=" prev, pager, next" :total="this.total_count"
					:current-page="SubmitObj.page_num"
					 @current-change="handleCurrentChange"
					>
				</el-pagination>
			</div>
		</div>

	</div>
</template>

<script>
	import {auditList} from '@/api/home.js'
	export default {

		data() {
			return {
				tableData: [],
				// 按钮列表
				btnList: [{
					title: '待审批'
				}, {
					title: '已审批'
				}, {
					title: '已完成'
				}, {
					title: '已转化'
				}],
				// 选中的按钮
				btnListindex: 0,
				// 总页数
				total_count:null,
				SubmitObj:{
					page_num:null
				}
			}
		},
		mounted() {
			this.auditLists(1)
		},
		methods: {
			// 跳转到审批详情
			ApprovalBtn(val){
				console.log(val)
				this.$router.push({path:'./homeApprovalDetails',query:{ids:val.item.id,mark:val.mark,type:val.item.ip_type}})
			},
			// 列表跳转
			handleCurrentChange(val){
				this.SubmitObj.page_num = val
				this.auditLists(this.btnListindex + 1 , 1)
			},
			// 审批列表
			async auditLists(val,SubmitObj){
				// 传的参数
				let result
				
				let obj = {
					 page_size:5
				}
				if(val == 1){
					obj.audit_result = 1
				}else if(val == 2){
					obj.audit_result = '2,3,4'
				}else if(val == 3){
					obj.status = 8
				}else if(val == 4){
					obj.achievement_status = 1
				}
				
				if(SubmitObj == 1){

					// // 待审批
					// result:1,
					// // 已审批
					// result:'2,3,4'
						obj.page_num = this.SubmitObj.page_num
				}else{
				}
				let res = await auditList(obj)
				if(res.code = '00000'){
					let aa = 'patent'
						this.tableData = res.data.result
						this.total_count = res.data.total_count
					
					// if(aa = 'patent'){
					// 	this.tableData = res.data.patent.result
					// 	this.total_count = res.data.patent.total_count
						
					// }else if( aa = 'software'){
					// 	this.tableData = res.data.software.result
					// 	this.total_count = res.data.software.total_count
					// }else if(aa = 'trademark'){
					// 	this.tableData = res.data.trademark.result
					// 	this.total_count = res.data.trademark.total_count
					// }
				}
			},
			// table 2的倍数行变色
			tableRowClassName({
				row,
				rowIndex
			}) {
				if (rowIndex % 2 == 0) {
					return 'warning-row';
				}
				return '';
			},

			btnclicke(item, index) {
				this.btnListindex = index
				this.auditLists(index+1)
			}
		}
	}
</script>

<style scoped="scoped" lang="less">
	.bigitembox {
		width: 100%;
		// height: 14.8vh;
		height: 22.2vh;
		margin-right: 24px;
		margin-top: 1.8vh;
		background: #FFFFFF;
		// box-shadow: 0px 2px 4px 3px rgba(0, 0, 0, 0.07);
		// border-radius: 5px;
		overflow: hidden;
	}



	.itemtop {
		height: 3.6vh;
		width: 100%;
		// border: 1px red solid;
		display: flex;
		justify-content: space-between;
		line-height: 3.6vh;

	}

	.itemtop .left {
		width: 7.6vw;
		background: url(../../assets/chengguo/1bgtop.png) no-repeat center;
		background-size: 100% 100%;
		color: #333333;
		font-size: 1.12rem;
		text-align: center;
		font-weight: bold;
		color: #FFFFFF;

	}

	.btnListbox {
		border-bottom: 1px solid #E5E5E5;
		margin-top: 1.4vh;
	}

	.btnList {
		display: flex;
		color: #666666;
		font-size: 1.12rem;

		div {
			padding-bottom: 1.5vh;
			margin-right: 1.3vw;
		}

		div.Select {
			font-weight: bold;
			color: #333333;
			border-bottom: 2px #0F7C63 solid;
		}
	}


	/deep/.el-table__header th {
		padding: 0;
		line-height: 3.7vh;
		height: 3.7vh;
		background: #F6FFF6;
		font-weight: bold;
		color: #666666;
		font-size: 0.88rem;

	}

	/deep/ .el-table__body td {
		padding: 0;
		height: 3.7vh;
		line-height: 3.7vh;
		color: #666666;
		font-size: 0.88rem;
	}

	/deep/.el-table--enable-row-hover .el-table__body tr:hover>td {
		background-color: #005E3A;
		color: #FFFFFF;
    cursor:pointer !important;
  }

	/deep/.el-table .warning-row {
		background: #F9F9F9;
	}
</style>
